import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { IAuthDataResolveData } from './auth-data.data';
import { AuthDataStore } from './auth-data.store';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthDataResolve implements Resolve<IAuthDataResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in auth-data.data.ts
    authData: AuthDataResolve,
  };

  constructor(private _authDataStore: AuthDataStore) {}

  resolve(route: ActivatedRouteSnapshot): Observable<IAuthDataResolveData> {
    return forkJoin(
      this._authDataStore.getAccountId(),
      this._authDataStore.getUserId(),
      this._authDataStore.isAuthenticated()
    ).pipe(
      map(([accountId, userId, isAuthenticated]) => ({
        accountId,
        userId,
        isAuthenticated,
      }))
    );
  }
}
